<template>
  <div class="box">
    <div class="main">
      <h1>预融评估审核页面</h1>

      <div>
        <commonTable
          :data="auditMessageList"
          :col-configs="tempColConfigsCheckInfo"
          :border="true"
          :currentPage="currentPage"
          :pageSize="pageSize"
          :count="count"
          emptytext="无"
        />
      </div>
      <div class="btn">
        <el-button @click="goSubmit(4, 'ruleFormfn2')">返回</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import commonTable from "./index.vue";
export default {
  components: { commonTable },
  name: "checkInfo",
  props: {
    auditMessageList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      listData: [],

      currentPage: 10,
      pageSize: 1,
      count: 0,
      tempColConfigsCheckInfo: [
        {
          type: "auditFlow",
          prop: "auditFlow",
          label: "审核流程",
          minWidth: 180,
          isShowTip: true,
        },
        {
          type: "oper",
          prop: "oper",
          label: "操作人",
          minWidth: 100,
          isShowTip: true,
        },
        {
          type: "role",
          prop: "role",
          label: "角色名称",
          minWidth: 120,
          isShowTip: true,
        },
        {
          type: "interfaceType",
          prop: "interfaceType",
          label: "接口方式",
          minWidth: 100,
          isShowTip: true,
          render: (operation, record, index) => {
            let obj = {
              PT: "平台接口",
              BL: "保理接口",
              RT: "建行接口",
              CMBC: "民生接口",
              ABC: "农行接口",
              CMB: "招商银行接口",
              CNCB: "中信银行接口",
              BOC: "中国银行接口",
              ICBC: "工行接口",
              HSB: "徽商银行",
              CIB:'兴业银行',
              BCM:'交通银行',
            };
            let value = obj[operation];
            return <div>{value}</div>;
          },
        },
        {
          type: "auditResult",
          prop: "auditResult",
          label: "意见结果",
          minWidth: 90,
          isShowTip: true,
        },
        {
          type: "auditMemo",
          prop: "auditMemo",
          label: "意见详情",
          minWidth: 180,
          isShowTip: true,
        },
        {
          type: "creatTime",
          prop: "creatTime",
          label: "日期",
          minWidth: 150,
          isShowTip: true,
        },
      ],
    };
  },

  created() {},
  mounted() {},
  methods: {
    goSubmit(type, formName) {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.box {
  width: 100%;
  padding: 0;
}

.main {
  margin-top: 8px;
  padding: 20px 4vw;
  background-color: #fff;
  box-shadow: 3px 3px 5px #e5e8f2;
  h1 {
    margin-bottom: 40px;

    font-size: 30px;
  }

  .wrap {
    width: 100%;

    display: flex;
    justify-content: center;
    .fromwrap {
      width: 34%;
      /deep/ .el-textarea__inner {
        height: 180px;
      }
    }
  }
}
.btn {
  text-align: center;
}
</style>
